export function sortByStartEndYearMonth(items) {
    const toNumber = (a) => (parseInt(a.startYear, 10) * 100 + parseInt(a.startMonth, 10)) * 1000000 +
        ((a.endYear ? parseInt(a.endYear, 10) * 100 : 0) +
            (a.endMonth ? parseInt(a.endMonth, 10) : 0));
    return [...items].sort((a, b) => toNumber(a) - toNumber(b));
}
export function sortProfileItemByStartEndYearMonth(items) {
    const toNumber = (a) => a.dateRange
        ? (parseInt(a.dateRange.start.year || '1970', 10) * 100 +
            parseInt(a.dateRange.start.month || '0', 10)) *
            1000000 +
            (parseInt(a.dateRange.end?.year || '9999', 10) * 100 +
                parseInt(a.dateRange.end?.month || '0', 10))
        : 0;
    return [...items].sort((a, b) => toNumber(a) - toNumber(b));
}
